import { useCallback } from "react";

const DEEP_BLUE = "#3182CE";
const BLUE = "#00B5D8";
const MUSTARD = "#D69E2E";
const PURPLE = "#805AD5";
const DARK_GREEN = "#319795";
const GREY = "#A0AEC0";
const PINK = "#D53F8C";
const BLACK = "#0000000f";

export const useBarColumnColorByType = () => {
  const getColor = useCallback((type: string) => {
    let color: string;

    switch (type) {
      case "ACH":
      case "ACH Checking":
        color = DEEP_BLUE;
        break;
      case "ECheck":
      case "ACH Saving":
        color = BLUE;
        break;
      case "Check":
        color = MUSTARD;
        break;
      case "Credit Card":
      case "Wire Transfer":
        color = PURPLE;
        break;
      case "From Impound":
      case "General Ledger":
        color = DARK_GREEN;
        break;
      case "From Escrow Account":
      case "To Escrow Account":
        color = GREY;
        break;
      case "External Payment":
        color = PINK;
        break;
      default:
        color = BLACK;
        break;
    }

    return color;
  }, []);

  return { getColor };
};
